<template>
  <section class="w-screen h-full dark:bg-gray-900 flex pb-32 pt-8">
      <div class="w-3/5 h-auto mx-auto flex rounded-lg dark:bg-gray-900">
        <span class="mx-auto text-gray-300 w-3/4">
          <span class="">
            <div v-if="!edit" class="h-48 w-48 bg-gray-800 animate-pulse rounded-full mx-auto">
            </div>
            <div><div class="w-96 mx-auto mt-4 h-5 bg-gray-500 rounded-full animate-pulse"></div></div>
            <div><div class="w-52 mx-auto mt-4 h-5 bg-gray-500 rounded-full animate-pulse"></div></div>
            <div><div class="w-24 mx-auto mt-4 h-5 bg-gray-500 rounded-full animate-pulse"></div></div>
          </span>
          <div class="mt-8 flex flex-wrap gap-y-4 gap-x-2">
            <div class="w-full"><div class="w-20 mt-4 h-5 bg-gray-500 rounded-full animate-pulse"></div></div> <!-- Sobre -->
            <div class="w-full"><div class="w-32 mt-4 h-4 bg-gray-500 rounded-full animate-pulse"></div></div> <!-- Dados pessoais -->
            <div class="w-full"><div class="w-full mt-4 h-8 bg-gray-500 rounded-lg animate-pulse"></div></div> <!-- Nome -->
            <div class="w-1/2"><div class="w-full mt-4 h-8 bg-gray-500 rounded-lg animate-pulse"></div></div> <!-- Email -->
            <div class="flex-1"><div class="w-full mt-4 h-8 bg-gray-500 rounded-lg animate-pulse"></div></div> <!-- Telefone -->
            <div class="flex-1"><div class="w-full mt-4 h-8 bg-gray-500 rounded-lg animate-pulse"></div></div> <!-- Ramal -->
            <div class="w-full"><div class="w-32 mt-4 h-4 bg-gray-500 rounded-full animate-pulse"></div></div> <!-- Dados Sensíveis -->
            <div class="w-1/2"><div class="w-full mt-4 h-8 bg-gray-500 rounded-lg animate-pulse"></div></div> <!-- Role -->
            <div class="w-full"><div class="w-24 mt-4 h-3 bg-gray-500 rounded-full animate-pulse"></div></div> <!-- Alterar Senha -->
            <div class="w-1/2"><div class="w-full mt-4 h-8 bg-gray-500 rounded-lg animate-pulse"></div></div> <!-- Senha -->
            <div class="flex-1"><div class="w-full mt-4 h-8 bg-gray-500 rounded-lg animate-pulse"></div></div> <!-- Confirmacao -->
          </div>
        </span>
      </div>
  </section>
</template>

<script>
export default {
  name: 'UserSkeleton',
  setup() {

    return {
    }
  }

}
</script>

<style>
</style>

